var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.proTypedialogVisible,
            title: _vm.title,
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.proTypedialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              staticClass: "formValidate mt20",
              attrs: {
                rules: _vm.rules,
                model: _vm.form,
                "label-width": "120px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "门票名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入门票名称" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商户商品分类：", prop: "cateIds" } },
                [
                  _c("el-cascader", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      options: _vm.merProductClassify,
                      props: _vm.props2,
                      clearable: "",
                      "show-all-levels": false,
                    },
                    model: {
                      value: _vm.form.cateIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "cateIds", $$v)
                      },
                      expression: "form.cateIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "入园时间", prop: "rysj" } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      "is-range": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "HH:MM:ss",
                    },
                    model: {
                      value: _vm.form.rysj,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "rysj", $$v)
                      },
                      expression: "form.rysj",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分类类型", prop: "ticketType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择分类类型" },
                      model: {
                        value: _vm.form.ticketType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "ticketType", $$v)
                        },
                        expression: "form.ticketType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "普通票", value: "1" },
                      }),
                      _c("el-option", { attrs: { label: "套票", value: "2" } }),
                      _c("el-option", { attrs: { label: "年卡", value: "3" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "核销人员", prop: "ticketType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.verificationUser,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "verificationUser", $$v)
                        },
                        expression: "form.verificationUser",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "可核销次数", prop: "canVerificationNum" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      placeholder: "请输入可核销次数",
                      min: 1,
                    },
                    model: {
                      value: _vm.form.canVerificationNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "canVerificationNum", $$v)
                      },
                      expression: "form.canVerificationNum",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "购买后X天有效", prop: "withinXDays" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      placeholder: "请输入天数",
                      min: 1,
                    },
                    model: {
                      value: _vm.form.withinXDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "withinXDays", $$v)
                      },
                      expression: "form.withinXDays",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标签名" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入标签名" },
                    model: {
                      value: _vm.form.tags,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "tags", $$v)
                      },
                      expression: "form.tags",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "入园地址" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入入园地址" },
                    model: {
                      value: _vm.form.admissionAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "admissionAddress", $$v)
                      },
                      expression: "form.admissionAddress",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "排序" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1 },
                    model: {
                      value: _vm.form.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sort", $$v)
                      },
                      expression: "form.sort",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "缩略图", prop: "image11" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "upLoadPicBox acea-row",
                      on: {
                        click: function ($event) {
                          return _vm.modalPicTap("1")
                        },
                      },
                    },
                    [
                      _vm.form.image11
                        ? _c("div", { staticClass: "pictrue" }, [
                            _c("img", { attrs: { src: _vm.form.image11 } }),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                    ]
                  ),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v("建议尺寸：800*800px，上传小于500kb的图片"),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "详情图：", prop: "sliderImages" } },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    [
                      _vm._l(_vm.form.sliderImages, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "pictrue",
                            attrs: { draggable: "true" },
                            on: {
                              dragstart: function ($event) {
                                return _vm.handleDragStart($event, item)
                              },
                              dragover: function ($event) {
                                $event.preventDefault()
                                return _vm.handleDragOver($event, item)
                              },
                              dragenter: function ($event) {
                                return _vm.handleDragEnter($event, item)
                              },
                              dragend: function ($event) {
                                return _vm.handleDragEnd($event, item)
                              },
                            },
                          },
                          [
                            _c("img", { attrs: { src: item } }),
                            _c("i", {
                              staticClass: "el-icon-error btndel",
                              on: {
                                click: function ($event) {
                                  return _vm.handleRemove(index)
                                },
                              },
                            }),
                          ]
                        )
                      }),
                      _vm.form.sliderImages.length < 10
                        ? _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap("2")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      "建议尺寸：800*800px，上传小于500kb的图片；最多可上传10张图片，拖动可调整顺序"
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "限购规则", prop: "limitBuyRuleIds" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.limitBuyRuleIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "limitBuyRuleIds", $$v)
                        },
                        expression: "form.limitBuyRuleIds",
                      },
                    },
                    _vm._l(_vm.options1, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退款规则", prop: "productReturnRuleIds" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.productReturnRuleIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "productReturnRuleIds", $$v)
                        },
                        expression: "form.productReturnRuleIds",
                      },
                    },
                    _vm._l(_vm.options2, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "价格" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "销售价",
                                "label-width": "60px",
                                prop: "salesPrice",
                              },
                            },
                            [
                              _c("el-input-number", {
                                attrs: { min: 0 },
                                model: {
                                  value: _vm.form.salesPrice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "salesPrice", $$v)
                                  },
                                  expression: "form.salesPrice",
                                },
                              }),
                              _vm._v(" 元 "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "市场价",
                                "label-width": "60px",
                                prop: "price",
                              },
                            },
                            [
                              _c("el-input-number", {
                                attrs: { min: 0 },
                                model: {
                                  value: _vm.form.price,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "price", $$v)
                                  },
                                  expression: "form.price",
                                },
                              }),
                              _vm._v(" 元 "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "日库存",
                                "label-width": "60px",
                                prop: "inventory",
                              },
                            },
                            [
                              _c("el-input-number", {
                                attrs: { min: 1 },
                                model: {
                                  value: _vm.form.inventory,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "inventory", $$v)
                                  },
                                  expression: "form.inventory",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "适用周" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.applicablePeriod,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "applicablePeriod", $$v)
                        },
                        expression: "form.applicablePeriod",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "周一" } }),
                      _c("el-checkbox", { attrs: { label: "周二" } }),
                      _c("el-checkbox", { attrs: { label: "周三" } }),
                      _c("el-checkbox", { attrs: { label: "周四" } }),
                      _c("el-checkbox", { attrs: { label: "周五" } }),
                      _c("el-checkbox", { attrs: { label: "周六" } }),
                      _c("el-checkbox", { attrs: { label: "周日" } }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.selectAllWeeks()
                        },
                      },
                    },
                    [_vm._v("全选")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退票规则" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择退票规则" },
                      model: {
                        value: _vm.form.agreement,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "agreement", $$v)
                        },
                        expression: "form.agreement",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "有效期内可退", value: "refundable" },
                      }),
                      _c("el-option", {
                        attrs: { label: "不可退", value: "non-refundable" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.refundType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "refundType", $$v)
                        },
                        expression: "form.refundType",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "无需手续" } }),
                      _c("el-checkbox", { attrs: { label: "需要手续" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.proTypedialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }